import useRolePermission from "entities/auth/hooks/useRolePermission";
import { useServicePrimaryTagListQuery } from "entities/tagTypes/queries/useServicePrimaryTagListQuery";
import { Tag } from "entities/tags/types";
import DeleteTagModal from "modules/tagsAndMetadataTags/components/DeleteTagModal";
import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import TableWithPagination from "shared/components/TableWithPagination";
import { StyledButton } from "../../../styled";
import PageFilterBar from "./components/PageFilterBar";
import TagDetails from "./components/TagDetails";
import { TagsPageProvider, useTagsPage } from "./context";
import { getTagsColumns } from "./helpers";

const TagsContainer = () => (
  <TagsPageProvider>
    <Tags />
  </TagsPageProvider>
);

const Tags: FC = () => {
  const tagsContextData = useTagsPage();
  const {
    tagsDetailsDrawer,
    setSelectedTag,
    setOpenModal,
    loading,
    tableData,
    tagTypeFilterData,
  } = tagsContextData;

  const { isFetching: isFetchingTagTypes } = useServicePrimaryTagListQuery();

  const writeAccess = useRolePermission("tags:write");

  const columnsParams = {
    tagsDetailsDrawer: tagsDetailsDrawer,
    setSelectedTag: setSelectedTag,
    setOpenModal: setOpenModal,
    tagTypes: tagTypeFilterData.options,
    readOnly: !writeAccess.allowed,
  };

  const columns = getTagsColumns(columnsParams);

  return (
    <>
      <SpaceBetweenCenter columnGap={"1rem"}>
        <PageFilterBar />
        {writeAccess.allowed && (
          <StyledButton
            title="Add new tag"
            size="small"
            onClick={() => tagsDetailsDrawer.openDrawer()}
          />
        )}
      </SpaceBetweenCenter>
      <TableWithPagination<Tag>
        columns={columns}
        emptyStateMessage="No Results Found"
        paginationMode="server"
        sortingMode="server"
        pageSizeOptions={[25, 50, 100]}
        loading={loading || isFetchingTagTypes}
        onRowClick={(params) => tagsDetailsDrawer.openDrawer(params.row)}
        {...tableData}
      />
      <TagDetails />
      <DeleteTagModal {...tagsContextData} />
    </>
  );
};
export default TagsContainer;
